<template>
  <v-container fluid>
    <EditWeightModal />
    <v-row>
      <v-col cols="12">
        <DataTable
          :headers="headers"
          :items="weights"
          module="Weight"
          model="weights"
          delete-callback="deleteWeightById"
          @handlePageChanged="getWeights"
          @handleEditItem="editWeight"
        >
          <template #top>
            <TableTopToolbar
              entity="Súly"
              title="Súlyok"
              model="weights"
              @filter="getWeights"
            />
          </template>
        </DataTable>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import EditWeightModal from '../../components/Weights/Modals/EditWeightModal'
import DataTable from '../../components/Table/DataTable'
import TableTopToolbar from '../../components/Table/TopToolbar/TableTopToolbar'

export default {
  name: "WeightsList",
  components: { EditWeightModal,DataTable,TableTopToolbar  },
  computed: {
    ...mapGetters("Weight", ["headers", "weights"])
  },
  mounted() {
    this.getWeights();
  },
  methods: {
    ...mapActions("Weight", ["getWeights", "editWeight"])
  }
};
</script>

<style></style>
